import { goToLink } from "@actions/common.js";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import LimitsIcon from "../../../../assets/icons/LimitsIcon.jsx";
import ArrowDownIcon from "../../../../assets/icons/ArrowDownIcon.jsx";
import BonusesIcon from "../../../../assets/icons/BonusesIcon.jsx";
import CashbackIcon from "../../../../assets/icons/CashbackIcon.jsx";
import DocumentsIcon from "../../../../assets/icons/DocumentsIcon.jsx";
import HistoryIcon from "../../../../assets/icons/HistoryIcon.jsx";
import MoneyIcon from "../../../../assets/icons/Money.jsx";
import NotificationIcon from "../../../../assets/icons/NotificationIcon.jsx";
import ProfileIcon from "../../../../assets/icons/ProfileIcon.jsx";
import WithdrawIcon from "../../../../assets/icons/Withdraw.webp";
import AccountInsightsIcon from "../../../../assets/icons/AccountInsightsIcon.jsx";
import { getMenuItems } from "../../../../constants/index.js";
import { DropdownWrapper, HeaderText, StyledMenu, StyledMenuItem } from "./elements.js";

const DropdownMenu = ({ goToLink, location, translate }) => {
	const [selectedItem, setSelectedItem] = useState(getMenuItems()[0].text);
	const [isDropdownOpen, setIsDropdownOpen] = useState(false);
	const dropdownRef = useRef(null);

	const handleMenuClick = (item) => {
		setSelectedItem(item.text);
		goToLink(item.link);
		setIsDropdownOpen(false);
	};

	useEffect(() => {
		const currentPath = location.pathname.split("?")[0].replace(/\/$/, "") || "/";
		const item = getMenuItems().find((menuItem) => menuItem.link === currentPath);

		if (item) {
			setSelectedItem(item.text);
		}
	}, [location.pathname]);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setIsDropdownOpen(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	const iconMap = {
		"Profile": <ProfileIcon color="#F7F7F7" />,
		"Notifications": <NotificationIcon />,
		"History": <HistoryIcon />,
		"Documents": <DocumentsIcon />,
		"My Bonuses": <BonusesIcon />,
		"Cashback": <CashbackIcon />,
		"Deposit": <MoneyIcon />,
		"Withdraw": <img src={WithdrawIcon} />,
		"Account insights": <AccountInsightsIcon />,
		"Limits": <LimitsIcon />,
	};

	const getVisibleMenuItems = () => {
		const menuItems = getMenuItems();

		if (location.pathname === "/profile/deposit" || location.pathname === "/profile/withdraw") {
			return menuItems.filter((item) => item.text === "Deposit" || item.text === "Withdraw");
		}

		return menuItems.filter((item) => item.text !== "Deposit" && item.text !== "Withdraw");
	};

	const filteredMenuItems = getVisibleMenuItems?.() || [];

	return (
		<div ref={dropdownRef}>
			<DropdownWrapper
				data-testid={
					location.pathname === "/profile/deposit" ||
					location.pathname === "/profile/withdraw"
						? "button-deposit-mode-selector"
						: "button-profile-menu-selector"
				}
				isDropdownOpen={isDropdownOpen}
				rotate={isDropdownOpen}
				onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
				{iconMap[selectedItem]}
				<HeaderText
					data-testid={
						location.pathname === "/profile/deposit" ||
						location.pathname === "/profile/withdraw"
							? "text-deposit-current-mode"
							: "text-profile-current-menu"
					}>
					{translate(selectedItem)}
				</HeaderText>
				<ArrowDownIcon />
			</DropdownWrapper>
			{isDropdownOpen && (
				<StyledMenu>
					{filteredMenuItems.map((item) =>
						item.text !== selectedItem ? (
							<StyledMenuItem
								data-testid={`button-profile-menu-${item.link.split("/").pop()}`}
								key={item.key}
								onClick={() => handleMenuClick(item)}>
								{iconMap[item.text]}
								{translate(item.text)}
							</StyledMenuItem>
						) : null
					)}
				</StyledMenu>
			)}
		</div>
	);
};

const mapStateToProps = () => ({});

const mapDispatchToProps = { goToLink };

export default connect(mapStateToProps, mapDispatchToProps)(DropdownMenu);
